// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomFieldResponse

import { CustomFieldAppRule, CustomFieldWidgetRule, CustomFieldType } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type CustomFieldApiResponse = {
	id: string;
	shortName: string;
	icon: string;
	publicName: string;
	publicDescription: string;
	appRule: CustomFieldAppRule;
	widgetRule: CustomFieldWidgetRule;
	visibleByCustomer: boolean;
	displayInBookingList: boolean;
	displayInBookingPreview: boolean;
	displayOnSession: boolean;
	applyOnAllBookings: boolean;
	applyOnActivities: string[];
	applyOnOffers: string[];
	applyOnSessions: string[];
	applyMinPax: number | null;
	applyMaxPax: number | null;
	attachToCustomer: boolean;
	archivedAt: string | null;
	sortOrder: number;
	fieldType: CustomFieldType;
	fieldSettings: { content?: string | null; minLength?: number | null; maxLength?: number | null; regex?: string | null; textarea?: boolean | null; min?: number | null; max?: number | null; decimal?: boolean | null; options?: Array<string> | null; addExtraOption?: boolean | null; restrict?: string | null; display?: string | null; relativeMin?: number | null; relativeMax?: number | null };
};

export type CustomField = {
	id: string;
	shortName: string;
	icon: string;
	publicName: string;
	publicDescription: string;
	appRule: CustomFieldAppRule;
	widgetRule: CustomFieldWidgetRule;
	visibleByCustomer: boolean;
	displayInBookingList: boolean;
	displayInBookingPreview: boolean;
	displayOnSession: boolean;
	applyOnAllBookings: boolean;
	applyOnActivities: string[];
	applyOnOffers: string[];
	applyOnSessions: string[];
	applyMinPax: number | null;
	applyMaxPax: number | null;
	attachToCustomer: boolean;
	archivedAt: DateTime | null;
	sortOrder: number;
	fieldType: CustomFieldType;
	fieldSettings: { content?: string | null; minLength?: number | null; maxLength?: number | null; regex?: string | null; textarea?: boolean | null; min?: number | null; max?: number | null; decimal?: boolean | null; options?: Array<string> | null; addExtraOption?: boolean | null; restrict?: string | null; display?: string | null; relativeMin?: number | null; relativeMax?: number | null };
};

export function hydrateCustomField(data: CustomFieldApiResponse): CustomField {
	return {
		...data,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}